(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cjx-batterijdeal"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('cjx-batterijdeal')) {
  customElements.define('cjx-batterijdeal', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-deal-data]').textContent);
      this.form = this.querySelector('form');
      this.mountSelect = this.querySelector('[data-mount]');
      this.variantSelect = this.form.elements.id;
      this.main = this.querySelector('[data-main-add]');
      this.repeats = [...this.querySelectorAll('[data-repeat-add]')];
      this.error = this.querySelector('[data-error]');
      this.sticky = this.querySelector('[data-sticky]');
      this.busy = false;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'nl-NL', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.mountSelect.addEventListener('change', () => this.update());
      this.variantSelect.addEventListener('change', () => {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.variantSelect.value);
        history.replaceState({}, '', url);
        this.update();
      });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.add(); });
      this.repeats.forEach(button => button.addEventListener('click', () => this.add()));
      this.querySelectorAll('[data-open-details]').forEach(link => link.addEventListener('click', () => {
        this.querySelector('.cjx-deal__details').open = true;
      }));
      this.observer = new IntersectionObserver(entries => {
        this.sticky.hidden = entries[0].isIntersecting;
      }, {threshold:0});
      this.observer.observe(this.main);
      this.update();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    format(cents) { return this.money.format(cents / 100); }
    update() {
      this.variant = this.data.variants.find(v => String(v.id) === this.variantSelect.value);
      this.mount = this.data.mounts[this.mountSelect.value];
      const mountCost = this.mount ? this.mount.price : 0;
      const total = (this.variant ? this.variant.price : 0) + mountCost;
      this.querySelectorAll('[data-total]').forEach(node => { node.textContent = this.format(total); });
      this.querySelector('[data-base-price]').textContent = this.format(this.variant ? this.variant.price : 0);
      this.querySelector('[data-mount-price]').textContent = this.format(mountCost);
      this.querySelector('[data-mount-row]').hidden = !this.mount || !this.mount.id;
      this.querySelector('[data-base-row]').hidden = !this.mount || !this.mount.id;
      this.querySelector('[data-mount-note]').textContent = this.mount ? this.mount.note : this.data.text.pending;
      this.querySelector('[data-mount-summary]').textContent = this.mount ? this.mount.label + ' — ' + this.mount.note : this.data.text.pending;
      const mountImage = this.querySelector('[data-mount-image]');
      mountImage.hidden = !this.mount || !this.mount.image;
      if (this.mount && this.mount.image) { mountImage.src = this.mount.image; mountImage.alt = this.mount.label; }
      const compare = this.variant && this.variant.comparison;
      const saving = compare ? compare - this.variant.price : 0;
      this.querySelector('[data-comparison]').hidden = !(saving > 0);
      this.querySelector('[data-separate-total]').textContent = this.format((compare || 0) + mountCost);
      this.querySelector('[data-saving]').textContent = this.format(Math.max(0, saving));
      this.available = !!this.variant && this.variant.available && (!this.mount || this.mount.available);
      this.querySelector('[data-availability]').textContent = this.available ? this.data.text.available : this.data.text.unavailable;
      [this.main,...this.repeats].forEach(button => { button.disabled = this.busy || !this.available; button.textContent = this.busy ? this.data.text.busy : this.data.text.add; });
      this.error.hidden = true;
      this.querySelector('[data-error-link]').hidden = true;
      this.mountSelect.removeAttribute('aria-invalid');
    }
    showError(message, uncertain = false) {
      this.error.textContent = message;
      this.error.hidden = false;
      this.querySelector('[data-error-link]').hidden = !uncertain;
      this.error.scrollIntoView({block:'center',behavior:'auto'});
    }
    async add() {
      if (this.busy) return;
      if (!this.mount) {
        this.mountSelect.setAttribute('aria-invalid','true');
        this.mountSelect.scrollIntoView({block:'center',behavior:'auto'});
        this.mountSelect.focus({preventScroll:true});
        this.error.textContent = this.data.text.required;
        this.error.hidden = false;
        return;
      }
      if (!this.available) { this.showError(this.data.text.unavailable); return; }
      this.busy = true;
      this.update();
      this.variantSelect.disabled = true;
      this.mountSelect.disabled = true;
      const items = [{id:this.variant.id,quantity:1,properties:{Montage:this.mount.label}}];
      if (this.mount.id) items.push({id:this.mount.id,quantity:1,properties:{'Bij pakket':'CJX Solar zonnepanelen + stekkerbatterij'}});
      let message = '';
      let uncertain = false;
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) { message = (typeof result.description === 'string' ? result.description + ' ' : '') + this.data.text.retry; uncertain = true; }
        else { location.assign(this.dataset.cartUrl); return; }
      } catch (error) { message = this.data.text.retry; uncertain = true; }
      this.busy = false;
      this.variantSelect.disabled = false;
      this.mountSelect.disabled = false;
      this.update();
      this.showError(message, uncertain);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cjx-contact-trust"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-cjx-plan-visit]');
  if (!trigger) return;
  const root = trigger.closest('[data-cjx-contact]');
  const select = root.querySelector('[data-cjx-contact-topic]');
  const option = select.querySelector('[data-cjx-visit-option]');
  select.value = option.value;
  select.dispatchEvent(new Event('change', { bubbles: true }));
  requestAnimationFrame(function() { select.focus({ preventScroll: true }); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
